interface ErrorTextProps {
    error: string | undefined
    className?: string
}
export const ErrorText = ({
    error,
    className
}: ErrorTextProps): JSX.Element => {
    return <span className={`text-danger text-sm ${className}`}>{error}*</span>
}
